<template>
	<el-drawer title="添加商品" :visible.sync="drawer" :append-to-body="true" class="apply-sample-drawer" :before-close="handleClose" size="724px">
		<div class="drawer-content">
			<div class="inhale">
				<div class="drawer-content-title fz-16 mb-24 mt-4">选择商品</div>
				<!-- 搜索框部分 -->
				<div class="pos-rela flex-row-align-center">
					<div class="custom flex-1 font-h6-regular yx-color-text-primary" @click="autoFocus">
						<span class="search-tag mr-12" v-if="thirdProductIds.length">
							<el-tag v-for="(tag, index) in thirdProductIds" :key="index" closable type="info" @close="closeTag(tag)" color="#F7F8FA">
								{{ tag }}
							</el-tag>
						</span>
						<input
							type="text"
							ref="input"
							v-model="textValue"
							class="search-input"
							placeholder="请输入商品名称/ID（商品ID支持多个搜索，按回车分隔）"
							@keydown.enter="blur"
							@blur="blur"
						/>
					</div>
					<el-button class="searchBtn" @click="search">搜索</el-button>
				</div>
			</div>
			<!-- 列表部分 -->
			<div class="table" v-loading="loading">
				<div v-show="tableData.length">
					<el-table
						header-row-class-name="table-header-row"
						row-class-name="table-row"
						:data="tableData"
						ref="multipleTable"
						@selection-change="handleSelectionChange"
						row-key="id"
						class="table-small"
					>
						<el-table-column type="selection" min-width="55" :selectable="({ productId }) => !hasSelectedGoods.includes(productId)"></el-table-column>
						<el-table-column label="商品信息" min-width="265">
							<template slot-scope="{ row }">
								<goodsBox :row="row" :platformId="platformId"></goodsBox>
							</template>
						</el-table-column>
						<el-table-column prop="livePrice" label="直播价" min-width="80">
							<template slot-scope="{ row }">
								<div class="font-h6-regular yx-color-text-primary">{{ row.price | formatPrice }}</div>
							</template>
						</el-table-column>
					</el-table>
					<yx-pagination
						:total="total"
						:current-page="pageInfo.page_index"
						:page-size="pageInfo.page_size"
						@size-change="sizeChange"
						@current-change="currentChange"
					></yx-pagination>
				</div>

				<div v-if="!tableData.length && !loading" class="empty-content">
					<img class="empty-search" src="@/assets/public/empty-search@2x.png" alt="" />
					<div class="fz-14 yx-color-text-secondary">搜索无结果</div>
				</div>
			</div>
		</div>

		<!-- 底部按钮部分 -->
		<div class="bott">
			<span class="pl-24 font-h5-regular yx-color-text-primary">
				已选
				<span class="yx-color-primary">{{ spuTotal || 0 }}</span>
				个，最多可选
				<span class="yx-color-primary">{{ maxSelected || 0 }}</span>
				个（SPU）
			</span>
			<div>
				<el-button @click="handleClose">取 消</el-button>
				<el-button type="primary" :disabled="isDisable" @click="add">确认添加</el-button>
			</div>
		</div>
	</el-drawer>
</template>
<script>
import goodsBox from './goodsBox';
import { productList } from '@/api/shopManage';
export default {
	props: {
		maxSelected: {
			type: [Number, String],
			default: 10,
		},
		platformId: [Number, String],
	},
	components: {
		goodsBox,
	},
	computed: {
		// 当前选中的SPU的总数量
		spuTotal({ hasSelectedGoods, selectionList }) {
			return hasSelectedGoods.length + selectionList.length;
		},
		isDisable({ spuTotal }) {
			return !spuTotal || spuTotal > 10;
		},
	},
	data() {
		return {
			drawer: false,
			thirdProductIds: [],
			tableData: [],
			pageInfo: {
				page_index: 1,
				page_size: 20,
			},
			hasSelectedGoods: [],
			selectionList: [],
			textValue: '',
			total: 0,
			loading: false,
		};
	},
	methods: {
		show(selectGoods) {
			this.hasSelectedGoods = Object.values(selectGoods).map(item => item[0].productId);
			this.drawer = true;
			this.getList();
		},
		async getList() {
			this.loading = true;
			const { platformId: platform_id, thirdProductIds, pageInfo } = this;
			let params = thirdProductIds.length
				? { platform_id, third_product_ids: thirdProductIds.join(','), ...pageInfo }
				: {
						platform_id,
						...pageInfo,
						product_name: this.textValue,
				  };
			const { list = [], page: { item_total } = {} } = await productList(params);
			this.total = item_total;

			this.tableData = list.map(({ live_price, product_id, product_name, product_pic, shop_name, third_product_id }) => ({
				price: live_price,
				productId: product_id,
				productName: product_name,
				productPic: product_pic,
				shopName: shop_name,
				thirdProductId: third_product_id,
			}));
			this.$nextTick(() => {
				this.loading = false;
			});
		},
		search() {
			this.pageInfo = {
				page_index: 1,
				page_size: 40,
			};
			this.getList();
		},
		blur() {
			if (!this.thirdProductIds.length) {
				if (this.funcNon(this.textValue)) {
					this.thirdProductIds.push(this.textValue);
					this.textValue = '';
				}
			} else {
				if (this.funcNon(this.textValue)) {
					this.thirdProductIds.push(this.textValue);
					this.textValue = '';
				} else {
					if (this.textValue) this.$message.warning('请输入商品ID');
					this.textValue = '';
				}
			}
		},
		autoFocus() {
			this.$refs.input.focus();
		},
		closeTag(tag) {
			this.thirdProductIds.splice(this.thirdProductIds.indexOf(tag), 1);
		},
		handleSelectionChange(val) {
			this.selectionList = val;
		},
		sizeChange(value) {
			this.pageInfo.page_size = value;
			this.getList();
		},
		currentChange(value) {
			this.pageInfo.page_index = value;
			this.getList();
		},
		add() {
			if (this.spuTotal > 10) return this.$message.warning('最多选择10个SPU');
			this.$emit('returnSelect', this.selectionList);
			this.handleClose();
		},
		funcNon(e) {
			let reg = /^\d+$/;
			return reg.test(e);
		},
		handleClose() {
			this.tableData = [];
			this.thirdProductIds = [];
			this.selectionList = [];
			this.$refs.multipleTable.clearSelection();
			this.textValue = '';
			this.pageInfo = {
				page_index: 1,
				page_size: 40,
			};
			this.drawer = false;
		},
	},
};
</script>
<style lang="less" scoped>
.drawer-content {
	padding: 0px 16px 16px 16px;
	background: @color-gy1;
	border-radius: 8px !important;
}
.apply-sample-drawer {
	/deep/ .el-drawer__body {
		border-top: 16px solid #f7f8f9;
		padding: 0 16px 16px 16px !important;
		background: #f7f8f9;
		padding-bottom: 64px !important;
	}
	.pos-rela {
		.custom {
			border: 1px solid #e0e0e0;
			padding: 4px 12px 0px 12px;
			border-right: none;
			overflow-y: hidden;
			&::-webkit-scrollbar {
				display: none;
			}
			.search-tag {
				.el-tag {
					margin-bottom: 4px;
				}
				.el-tag + .el-tag {
					margin-left: 10px;
				}
			}
			input::placeholder {
				color: #86909d;
			}
			.search-input {
				margin-bottom: 4px;
				width: 330px;
				line-height: 24px;
				height: 24px;
				font-size: 13px;
				caret-color: @color-primary;
			}
		}
		.searchBtn {
			width: 72px;
			background-color: @color-primary;
			color: @color-white;
			font-size: 13px;
			border-radius: 2px;
			height: 34px;
		}
	}

	.table {
		min-height: calc(100vh - 300px);
		/deep/ .el-table td.el-table__cell {
			color: #1d2129;
			font-size: 14px;
		}
		/deep/ .el-table-column--selection .cell{
			padding-left: 16px;
			padding-right: 16px;
		}
		.num {
			/deep/ .el-input-number__decrease,
			/deep/ .el-input-number__increase {
				background-color: #f7f8fa;
			}
			/deep/ .el-input-number__decrease {
				border-right: 1px solid #f0f1f5;
			}
			/deep/ .el-input-number__increase {
				border-left: 1px solid #f0f1f5;
			}
		}
		.specification {
			width: 76px;
			overflow: hidden;
			text-overflow: ellipsis;
			display: -webkit-box;
			-webkit-line-clamp: 2;
			-webkit-box-orient: vertical;
		}
	}
	.bott {
		position: absolute;
		bottom: 0;
		left: 0;
		height: 64px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding-right: 20px;
		width: 100%;
		/* 超/灰/G1 */
		background: @color-gy1;
		box-shadow: 0px -2px 10px 0px rgba(0, 0, 0, 0.1);
		z-index: 2000;
		/deep/ .el-pagination__jump{
			margin-left: 0px !important;
		}
	}
}
.table-small {
	overflow: visible;
	/deep/ .table-header-row {
		background: @color-gy3;
	}

	/deep/ .el-table__header-wrapper {
		position: sticky;
		top: 127px;
		z-index: 10;
	}
	/deep/ .el-table__cell {
		background: none;
	}
	/deep/ th.el-table__cell {
		padding: 8px 0 8px 0px !important;
	}
	/deep/ .cell {
		font-size: 14px !important;
		color: @color-regular !important;
		font-weight: normal !important;
	}
}
.drawer-content-title {
	position: relative;
	color: @color-gy9;
	font-weight: 500;
	padding-left: 8px;
}
.drawer-content-title::after {
	content: '';
	width: 3px;
	height: 17px;
	background: @color-b4;
	border-radius: 20px;
	position: absolute;
	left: 0px;
	top: 50%;
	transform: translateY(-50%);
}
.inhale {
	padding: 20px 0 24px 0;
	background: @color-gy1;
	position: sticky;
	top: 0px;
	z-index: 2;
}
.empty-content{
	text-align: center;
	height: calc(100vh - 300px);
	.empty-search{
		margin-top: 76px;
		width: 96px;
		height: 96px;
	}
}
</style>
